import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { api } from "../evergis/api";
import { getProfilePhoto, setProfilePhoto } from "../ducks/user";

export const useProfilePhoto = (username?: string) => {
  const dispatch = useDispatch();
  const profilePhoto = useSelector(getProfilePhoto);

  useEffect(() => {
    if (profilePhoto || !username) return;

    (async () => {
      const url = api.accountPreview.getPreview("");
      const response = await fetch(url);

      if (response.status !== 200) return;

      const photo = response.headers.get("content-type")?.includes("text/plain")
        ? await response.text()
        : `${url}?r=${Math.random()}`;

      dispatch(setProfilePhoto(photo));
    })();
  }, [username]);
};
